const getDate = (date, returnDate = true) =>
    date?.split(" ")?.[returnDate ? 0 : 1];

const cleanDates = (statDates, returnDate = true) =>
    statDates
        ?.map((statDate) => getDate(statDate, returnDate))
        ?.reduce((acc, cur) => {
            !acc?.includes(cur) && acc?.push(cur);
            return acc;
        }, []);

const prepareChartData = ({
    statDatesAmended,
    statsAmended,
    pageNames,
    formNames,
    sourceName,
    returnDate = true,
}) => {
    return statDatesAmended?.map((statDate) => {
        const initChartEntry = {
            date: statDate,
        };

        const sameStats = statsAmended?.filter(
            (stat) => stat?.successfully_sent_at === statDate,
        );

        pageNames?.forEach((pageName, index) => {
            initChartEntry[`page_${index}`] = sameStats
                ?.filter((item) => item?.page_name === pageName)
                ?.reduce((acc, cur) => acc + cur?.sent_operation_count, 0);
        });

        formNames?.forEach((formName, index) => {
            initChartEntry[`form_${index}`] = sameStats
                ?.filter((item) => item?.form_name === formName)
                ?.reduce((acc, cur) => acc + cur?.sent_operation_count, 0);
        });

        if (
            statsAmended?.find(
                (stat) =>
                    stat?.name === sourceName &&
                    !stat?.form_name &&
                    !stat?.page_name,
            )
        )
            initChartEntry.name = statsAmended?.reduce((acc, cur) => {
                if (cur?.name === sourceName && cur?.successfully_sent_at === statDate) {
                    return acc + cur?.sent_operation_count;
                } else return acc;
            }, 0);
        return initChartEntry;
    });
};

export const getChartData = ({
    stats,
    statDates,
    pageNames,
    formNames,
    sourceName,
    returnDate = true,
}) => {
    const statDatesAmended = cleanDates(statDates, returnDate);
    const statsAmended = stats?.map((stat) => ({
        ...stat,
        successfully_sent_at: getDate(stat?.successfully_sent_at, returnDate),
    }));

    return prepareChartData({
        statDatesAmended,
        statsAmended,
        returnDate: false,
        pageNames,
        formNames,
        sourceName,
    });
};
